export default function removeMultiImager(state, action) {
  const { id, lensIds, idToSwitchTo } = action
  const { cameras } = state

  if (!idToSwitchTo) return Object.assign({}, state, { cameras: [], currentEntity: { type: 'map' } })

  const cameraToSwitchTo = Object.assign({}, cameras.find(c => c.id === idToSwitchTo), { active: true })

  return Object.assign(
    {},
    state,
    {
      cameras: [
        ...cameras.filter(c => c.id !== id && c.id !== idToSwitchTo && !lensIds.includes(c.id)),
        cameraToSwitchTo
      ],
      currentEntity: { type: 'camera', id: idToSwitchTo }
    }
  )
}



// WEBPACK FOOTER //
// ./src/reducers/removeMultiImager.js